import { localContentPrefix } from '../../../../config';
import { http } from '../../../axios';

export function fetchLocalContentGenreCategories(fiction: boolean) {
    return http
        .get<Record<string, string>>(`${localContentPrefix}/v1/localcontent/genres/categories`, {
            params: { fiction }
        })
        .then(({ data }) => data);
}
